export default __webpack_public_path__ + "static/media/pammContentIcon5.6e3ab595.webp";